import   { useState, useContext, useEffect } from 'react';
import Modal from './index';
import { ModalContext } from '../ModalContext';
import { useForm,   Controller } from "react-hook-form"
//import API from '../API'
import { AdminReloadFunction } from '../interfaces';
import { AdminQueryPosition, AdminQueryPositionRate } from '../../../backend/src/api/dto';
import DatePicker from 'react-datepicker';

type FormValues = {
    ratePerHour: string | number
    startDate: string | Date
    endDate: string | Date | null
}

function AdminAddPositionRateToPosition({ item, parent, reload, addFunction }: {
    item: AdminQueryPositionRate | null,
    parent: AdminQueryPosition,
    reload: AdminReloadFunction,
    addFunction: any,
}) {

    const [showModal, closeModal] = useContext(ModalContext);
    const { register, control, handleSubmit, getValues, } = useForm<FormValues>({
        defaultValues: {
            ratePerHour: item ? item.ratePerHour : '',
            startDate: item ? new Date(item.startDate) : '',
            endDate: item && item.endDate ? new Date(item.endDate) : null
        }
    })

    const [loading, setLoading] = useState(true);
    const [sending, setSending] = useState(false);
    //  const [data, setData] = useState<AdminProjectsAndOrdersResponse>();
    const [apiResult, setApiResult] = useState<null | { status: boolean }>(null)


    useEffect(() => {
        // API.getProjectsAndOrders({divisionMatch: 'true'}).then(data => {
        //     setData(data)
        // })
    }, [])

    const modalButtons = [
        {
            text: 'Confirm',
            icon: 'check',
            onClick: () => onSubmit(),

            style: 'primary'
        }, {
            text: 'Cancel',
            icon: 'xmark',
            onClick: 'closeModal',
            style: 'secondary'
        }
    ];


    const onSubmit = () => {
        //const form = getValues();
        setSending(true);
        return new Promise((resolve, reject) => {
            handleSubmit((data2) => {
                setLoading(false);
                setApiResult({
                    status: true,
                })
                addFunction(data2.ratePerHour).then(() => {
                    if (reload) {
                        console.log('in reload')
                        reload().then(() => {
                            closeModal(null);
                            resolve(1)
                        })
                    } else {
                        closeModal(null);
                        resolve(1)
                    }
                }).catch((e: any) => {
                    setLoading(false);
                    setApiResult(e)
                    resolve(1)
                })
                setSending(false)
            })()
        })
    }

    return (
        <Modal
            buttons={modalButtons}
            title={'Pridať hodinovú sadzbu pozícii'}
            errorObject={apiResult}
            disableAllButtons={sending}
        >
            <form style={{ minHeight: '380px' }}>
                <div className="row mb-2">
                    <div className="col-4 text-end">
                        Pozícia
                    </div>
                    <div className="col-auto">
                        {parent.name}
                    </div>
                </div>
                <div className="row">
                    <div className="col-4 mt-1 text-end">
                        <label className="form-label">Hodinová sadzba</label>
                    </div>
                    <div className="col-auto">
                        <input type="text" {...register("ratePerHour")} />
                    </div>
                </div>
                <div className="row">
                    <div className="col-4 mt-1 text-end">
                        <label className="form-label">Od </label>
                    </div>
                    <div className="col-auto">
                        <Controller
                            control={control}
                            name='startDate'
                            render={({ field }) => (
                                <DatePicker
                                    onChange={(date) => field.onChange(date)}
                                    selected={field.value ? new Date(field.value) : null}
                                    dateFormat='YYYY-MM-dd'
                                />
                            )}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-4 mt-1 text-end">
                        <label className="form-label">Do</label>
                    </div>
                    <div className="col-auto">
                        <Controller
                            control={control}
                            name='endDate'
                            render={({ field }) => (
                                <DatePicker
                                    onChange={(date) => field.onChange(date)}
                                    selected={field.value ? new Date(field.value) : null}
                                    dateFormat='YYYY-MM-dd'
                                />
                            )}
                        />
                    </div>
                </div>
            </form>
        </Modal>
    )

}

export default AdminAddPositionRateToPosition
